import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import blue from '@material-ui/core/colors/blue';
import './signalr/connection';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './App.css';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: blue[900]
        }
    },
    typography: {
        fontFamily: [
            //'Roboto',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
    overrides: {
        // Name of the component / style sheet
        MuiCircularProgress: {
            // Name of the rule
            root: {
                marginLeft: 'auto',
                marginRight: 'auto',
                display: 'block'
            },
        },
    },
});


setTimeout(() => {
    setInterval(function () {

        let pageSizeSelector = document.querySelectorAll('.MuiTablePagination-select div');
        if (pageSizeSelector.length > 0) {
            let pageSize = parseInt(pageSizeSelector[0].innerText)

            let userSettings = JSON.parse(localStorage.getItem("userSettings"));
            let existingPageSize = userSettings.pageSize;
            if (existingPageSize != pageSize) {
                userSettings.pageSize = pageSize;
                localStorage.setItem('userSettings', JSON.stringify(userSettings));
            }

            if (pageSize > 20) {
                window.document.getElementById('additionalStyles').innerHTML = `.MuiContainer-root > div > .MuiPaper-root > .MuiToolbar-root {
                                                                                position: fixed;
                                                                                background-color: white;
                                                                                z-index: 1000;
                                                                                box-shadow: 0px 0px 0px 0px rgba(0,0,0,0), 0px 4px 5px 0px rgba(0,0,0,0.24), 0px 0px 0px 0px rgba(0,0,0,0)
                                                                            }
                                                                              .MuiContainer-root > div > .MuiPaper-root > .MuiToolbar-root + div {
                                                                                    position: relative;
                                                                                    top: 91px;
                                                                                }

                                                                                    .MuiContainer-root > div > .MuiPaper-root > .MuiToolbar-root + div + table {
                                                                                        position: relative;
                                                                                        top: 91px;
                                                                                    }`;

                let heading = window.document.querySelectorAll('.MuiContainer-root > div > .MuiPaper-root > .MuiToolbar-root');
                if (heading.length) {
                    let height = heading[0].offsetHeight;
                    heading[0].setAttribute('style', `width: ${heading[0].parentElement.offsetWidth}px`);
                    heading[0].nextSibling.setAttribute('style', `top: ${height + 10}px; position: relative;`);
                    heading[0].nextSibling.nextSibling.setAttribute('style', `top: ${height + 10}px; position: relative;`);
                }
                
            }
            else {
                window.document.getElementById('additionalStyles').innerHTML = '';

                let heading = window.document.querySelectorAll('.MuiContainer-root > div > .MuiPaper-root > .MuiToolbar-root');
                if (heading.length) {
                    heading[0].nextSibling.setAttribute('style', ``);
                    heading[0].nextSibling.nextSibling.setAttribute('style', ``);
                }
            }
        }
    }, 200);
}, 0);
// a way to persist page size... 


// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);
window.store = store;
const rootElement = document.getElementById('root');

let userSettings = JSON.parse(localStorage.getItem("userSettings"));
if (!userSettings)
    userSettings = {};

// user settings defaults
if (userSettings['monitoringConnection'] === undefined) userSettings['monitoringConnection'] = "Monitoring DB";
if (userSettings['leftSidebarOpen'] === undefined) userSettings['leftSidebarOpen'] = true;
if (userSettings['selectedFilter'] === undefined) userSettings['selectedFilter'] = 'all';
if (userSettings['pageSize'] === undefined) userSettings['pageSize'] = 15;
localStorage.setItem('userSettings', JSON.stringify(userSettings));

history.listen(location => {
    //console.log(location);
    //let charts = document.querySelectorAll('.chartjs-render-monitor');
    //charts.forEach(c => {
    //    c.getContext("2d")
    //});
});

ReactDOM.render(
    <ThemeProvider theme={theme}>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <App />
                </MuiPickersUtilsProvider>
            </ConnectedRouter>
        </Provider>
    </ThemeProvider>,
    rootElement);

registerServiceWorker();
